import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import {
    CreateNotificationTemplate,
    NotificationTemplate,
    NotificationTemplateListResponse,
    NotificationTemplateQueryParams,
    UpdateNotificationTemplate
} from '@frontend/notification/types';

export class NotificationTemplateClient extends APIClient {
    public static readonly endpoint = '/notification-api/v1';

    public static async fetchNotificationTemplates(queryParams?: ApiQueryParams<NotificationTemplateQueryParams>): Promise<NotificationTemplateListResponse> {
        return await this.apiPaginated<NotificationTemplateListResponse, NotificationTemplateQueryParams>(`${this.endpoint}/templates`, queryParams);
    }

    public static async resolveNotificationTemplates(ids: string[], field: string = 'id'): Promise<NotificationTemplateListResponse> {
        return this.resolve<NotificationTemplateListResponse>(`${this.endpoint}/templates`, ids, field);
    }

    public static async deleteNotificationTemplates(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/templates-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postNotificationTemplate(accountId: string, body: CreateNotificationTemplate): Promise<NotificationTemplate> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/templates`, body);
        return await this.handleResponse<NotificationTemplate>(response);
    }

    public static async fetchAccountNotificationTemplate(accountId: string, templateId: string): Promise<NotificationTemplate> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/templates/${templateId}`);
        return await this.handleResponse<NotificationTemplate>(response);
    }

    public static async patchNotificationTemplate(accountId: string, templateId: string, body: UpdateNotificationTemplate): Promise<NotificationTemplate> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/templates/${templateId}`, body);
        return await this.handleResponse<NotificationTemplate>(response);
    }

    public static async deleteNotificationTemplate(accountId: string, templateId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/templates/${templateId}`);
        return await this.handleVoidResponse(response);
    }
}
